<template>
  <div class="login-dialog--login__content-container--text">
    <h2 class="login-dialog--login__content-container--text__title primary-font">{{ title }}</h2>
    <span class="login-dialog--login__content-container--text__subtitle secondary-font"
      :style="layout == 'portal' ? '' : 'color: #222222'">{{ description }}</span>
    <v-form v-model="validated">
      <v-text-field ref="passwordInput" :background-color="layout == 'portal' ? '' : 'var(--v-primary-opacity-12)'"
        :rules="requireValidation ? [rules.required, rules.password] : []" :error-messages="error"
        :class="layout == 'portal' ? 'portal-theme' : ''"
        class="login-dialog--login__content-container--text__input login-dialog--login__content-container--text__input--single" v-model="password"
        :type="passwordVisible ? 'text' : 'password'" @click:append="passwordVisible = !passwordVisible"
        :append-icon="passwordVisible ? 'fxt-eye' : 'fxt-eye-off'" placeholder="Passord"
        :autocomplete="requireValidation ? 'password' : 'new-password'" @input="onInput" @keydown.enter="submit"
        validate-on-blur></v-text-field>
    </v-form>
  </div>
</template>
<script>
export default {
  name: "the-password",
  components: {

  },
  props: {
    description: {},
    title: {},
    requireValidation: {
      default: true,
      type: Boolean,
      required: false
    },
    error: {
      required: false,
      default: '',
      type: String
    },
    layout: {
      required: false,
      default: 'chain',
      type: String
    }
  },
  data() {
    return {
      password: '',
      passwordVisible: false,
      validated: false,
      rules: {
        required: value => !!value || 'Dette feltet er obligatorisk.',
        password: value => {
          const pattern = /^(?=.*\d)(?=.*[A-Z])[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]{8,}$/
          return pattern.test(value) || 'Passord må inneholde minimum 8 tegn, minst ett tall og en stor bokstav.'
        },
      },
    };
  },
  methods: {
    submit(event) {
      event.preventDefault();
      this.onInput(event?.srcElement?._value)
      this.$emit("verify");
    },
    onInput(value) {
      this.$emit("setValue", value);
    },
    validate() {
      return this.validated
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.passwordInput.$refs.input.focus()
      })
    })
  }
}
</script>
<style lang="scss" scoped>
  .portal-theme.theme--light.v-text-field:not(.v-input--has-state) {
    color: #579FA7 !important;
  }
</style>
  